import classNames from 'classnames/bind'

import styles from './LogValue.module.scss'

import type {LogValueNode} from '../../type'
import type {FC} from 'react'

const cx = classNames.bind(styles)

interface PrimitiveProps {
    node: LogValueNode
}

const Primitive: FC<PrimitiveProps> = ({node}) => {
    return <span className={cx('primitiveValue', node.type)}>{node.preview}</span>
}

export default Primitive
